<template>
    <!--    <img alt="Vue logo" src="../assets/logo.png">-->
    <!--    <HelloWorld msg="Welcome to Your Vue.js App"/>-->
    <div>
        <login></login>
        <updatesModal ref="elemSelected" v-if="validateUser()"></updatesModal>
        <section class="main-banner">
            <div class="container">
                <div class="row">
                    <div class="col-md-6">
                        <div class="banner-heading">Start Your Dream Career from Here</div>
                        <div class="banner-sub-heading">Search for jobs and internships, Grab the chance to get your
                            dream career started
                        </div>
                        <div class="get-started-btn">
                            <div v-if="whetherLogged">
                                <router-link to="/companies">
                                    <div class="cta">
                                        <span>GET STARTED</span>
                                        <Span>
                                        <svg width="13px" height="12px" viewBox="0 0 13 10">
                                            <path d="M1,5 L11,5"></path>
                                            <polyline points="8 1 12 5 8 9"></polyline>
                                        </svg>
                                        </Span>
                                    </div>
                                </router-link>
                            </div>
                            <div v-else>
                                <div class="cta" @click="authModal()">
                                    <span>GET STARTED</span>
                                    <span>
                                    <svg width="13px" height="12px" viewBox="0 0 13 10">
                                        <path d="M1,5 L11,5"></path>
                                        <polyline points="8 1 12 5 8 9"></polyline>
                                    </svg>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="banner-image">
                            <img src="/images/index/onestop.png" alt="">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="stats-ey students-stats">
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                1500+ <p>Companies</p>
                                <span><img src="/images/college-landing-page/companies.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                50000+ <p>Jobs</p>
                                <span><img src="/images/college-landing-page/jobs.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                15000+ <p>Internships</p>
                                <span><img src="/images/college-landing-page/internship.png" alt=""></span>
                            </div>
                        </div>
                        <div class="col-md-3 col-sm-6">
                            <div class="stat-box">
                                100+ <p>Colleges</p>
                                <span><img src="/images/college-landing-page/internship.png" alt=""></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!--        <section class="index-coms">-->
        <!--            <div class="container">-->
        <!--                <div class="index-box">-->
        <!--                    <div class="row">-->
        <!--                        <div class="col-md-6">-->
        <!--                            <h1 class="main-heading">Companies</h1>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;                            <div class="col-md-6" v-if="companiesLength">&ndash;&gt;-->
        <!--                        <div>-->
        <!--                            <div class="view-all-btn">-->
        <!--                                <router-link to="/companies">View All</router-link>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                        &lt;!&ndash;                                <div v-if="whetherLogged">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                    <div class="view-all-btn">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                        <router-link to="/companies">View All</router-link>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                    </div>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                </div>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                <div v-else>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                    <div class="view-all-btn" @click="authModal()">&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                        <a href="JavaScript:void(0);">View All</a>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                    </div>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                                </div>&ndash;&gt;-->
        <!--                        &lt;!&ndash;                            </div>&ndash;&gt;-->
        <!--                    </div>-->
        <!--                    <div class="row">-->
        <!--                        <div class="col-md-4 col-sm-6" v-for="company in companies">-->
        <!--                            <div class="cp-com-box">-->
        <!--                                <div class="cp-com-logo">-->
        <!--                                    <router-link :to="{path: '/profile?slug=' + company.organizationEnc.org_slug}"><img-->
        <!--                                            v-bind:src="company.organizationEnc.logo" alt=""></router-link>-->
        <!--                                </div>-->
        <!--                                <div class="cp-com-name">-->
        <!--                                    <router-link :to="{path: '/profile?slug=' + company.organizationEnc.org_slug}">{{company.organizationEnc.organization_name}}-->
        <!--                                    </router-link>-->
        <!--                                </div>-->
        <!--                                <div class="cp-com-category">-->
        <!--                                    {{company.organizationEnc.business_activity}}-->
        <!--                                </div>-->
        <!--                                <div class="cp-com-opper">-->
        <!--                                    Jobs Available : <span>{{company.organizationEnc.jobs_count}}</span>-->
        <!--                                </div>-->
        <!--                                <div class="cp-com-opper">-->
        <!--                                    Internships Available : <span>{{company.organizationEnc.internships_count}}</span>-->
        <!--                                </div>-->
        <!--                                <div class="cp-view-btn">-->
        <!--                                    <router-link :to="{path: '/profile?slug=' + company.organizationEnc.org_slug}">View Company-->
        <!--                                    </router-link>-->
        <!--                                    &lt;!&ndash;                                        <a v-if="whetherLogged" v-bind:href="company.profile_link">View Company</a>&ndash;&gt;-->
        <!--                                    &lt;!&ndash;                                        <a v-else @click="authModal()">View Company</a>&ndash;&gt;-->
        <!--                                </div>-->
        <!--                            </div>-->
        <!--                        </div>-->
        <!--                    </div>-->
        <!--                </div>-->
        <!--            </div>-->
        <!--        </section>-->
        <section class="index-profiles">
            <div class="container">
                <div class="index-box">
                    <div class="row">
                        <div class="col-md-6">
                            <h1 class="main-heading">Profiles</h1>
                        </div>
                        <div class="col-md-6" v-if="profilesLength">
                            <div>
                                <div class="view-all-btn">
                                    <router-link to="/jobs">View All</router-link>
                                </div>
                            </div>
                            <!--                                <div v-if="whetherLogged">-->
                            <!--                                    <div class="view-all-btn">-->
                            <!--                                        <router-link to="/jobs">View All</router-link>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                            <!--                                <div v-else>-->
                            <!--                                    <div class="view-all-btn" @click="authModal()">-->
                            <!--                                        <a href="JavaScript:void(0);">View All</a>-->
                            <!--                                    </div>-->
                            <!--                                </div>-->
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-3 col-sm-6 col-xs-12 category" v-for="profile in profiles">
                            <div>
                                <router-link :to="{path: '/jobs?keyword=' + profile.name}">
                                    <div class="grids">
                                        <img class="grids-image" v-bind:src="profile.icon">
                                    </div>
                                    <h4 class="name">{{profile.name}}</h4>
                                </router-link>
                            </div>
                            <!--                            <div v-if="whetherLogged">-->
                            <!--                                <router-link :to="{path: '/jobs?profile=' + profile.name}">-->
                            <!--                                    <div class="grids">-->
                            <!--                                        <img class="grids-image" v-bind:src="profile.icon">-->
                            <!--                                    </div>-->
                            <!--                                    <h4 class="name">{{profile.name}}</h4>-->
                            <!--                                </router-link>-->
                            <!--                            </div>-->
                            <!--                            <div v-else>-->
                            <!--                                <a href="JavaScript:void(0);" @click="authModal()">-->
                            <!--                                    <div class="grids">-->
                            <!--                                        <img class="grids-image" v-bind:src="profile.icon">-->
                            <!--                                    </div>-->
                            <!--                                    <h4 class="name">{{profile.name}}</h4>-->
                            <!--                                </a>-->
                            <!--                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="serv-offered">
            <div class="container">
                <div class="index-box">
                    <div class="row">
                        <div class="col-md-12">
                            <h1 class="main-heading">Services Offered</h1>
                        </div>
                        <div class="col-md-4">
                            <div class="serv-box">
                                <div class="serv-logo">
                                    <img src="/images/student/campus-placement.png">
                                </div>
                                <h3>Campus Placements</h3>
                                <p class="serv-content">Get yourself placed in top companies right after your graduation. Participate in our campus placement drive every year.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="serv-box">
                                <div class="serv-logo">
                                    <img src="/images/student/edu-loan.png">
                                </div>
                                <h3>Education Loan</h3>
                                <p class="serv-content">Thinking of studying abroad or about your post graduation? Apply for education loan at best interest rates offered.</p>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="serv-box">
                                <div class="serv-logo">
                                    <img src="/images/student/webinar.png">
                                </div>
                                <h3>Webinars</h3>
                                <p class="serv-content">Attend our webinars conducted in partnership with top tier industry experts and grow your knowledge. Learn their tips and tricks to succeed.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="how-it-works">
            <div class="container">
                <div class="row">
                    <div class="col-md-12">
<!--                        <h1>How it Works</h1>-->
                        <h1 class="main-heading">How it Works</h1>
                    </div>
                </div>
                <div class="row steps">
                    <div class="col-sm-4">
                        <div class="step">
                            <span></span>
                            <img src="https://user-images.githubusercontent.com/72601463/147323987-bda9878d-c7bc-49fb-be1f-a70e2a3c70b0.png">
                            <h3>Sign Up</h3>
                            <p>You can't afford to be passive about your career. Sign up and make it a priority!</p>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="step">
                            <span></span>
                            <img src="https://user-images.githubusercontent.com/72601463/147324004-f692e26b-31a9-4d00-ab7e-917e452fd740.png">
                            <h3>Explore Jobs & <br>Internships</h3>
                            <p>We help students to create a career that fits their interests and provides opportunities for learning.</p>
                        </div>
                    </div>
                    <div class="col-sm-4">
                        <div class="step">
                            <span></span>
                            <img src="https://user-images.githubusercontent.com/72601463/147324006-41e7bda9-8841-46ba-a11b-a61c308ee4f2.png">
                            <h3>Apply</h3>
                            <p>The door to your dreams is waiting for you, so what are you waiting for? Make it happen!</p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <section class="companies index-coms">
            <div class="container">
                <div class="index-box-coms">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="com-grid featured-com">
                                <h1 class="main-heading">Featured Companies</h1>
                                <div class="ac-subheading">Companies recruiting top talent from our portal.</div>
                                <!--<div class="all-coms"><a href="/organizations">View All Companies</a></div>-->
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-2 col-sm-4 col-xs-6" v-for="f in featuredComs">
                            <div class="cmp-main">
                                <div class="cmp-log">
                                    <img v-bind:src="f.organization_logo"
                                       v-bind:alt="f.name" v-bind:title="f.name">
                                </div>
                                <div class="cmp-name">{{f.name}}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<style scoped>
.com-grid{
    min-height: unset;
}
.featured-com{
  text-transform: capitalize;
  margin-bottom: 30px;
}
.cmp-main {
  border: 2px solid transparent;
  text-align: center;
  padding: 10px 5px;
  margin-bottom: 20px;
  background-color: #fff;
  border-radius: 5px;
  height: 140px !important;
  cursor: pointer;
  transition: all 0.3s;
  box-shadow: 0 0 8px rgba(0,0,0,.2);
}
.cmp-log {
  width: 65px;
  margin: auto;
  height: 65px;
  line-height: 61px;
  transition: all 0.3s;
}
.cmp-log img{
  width: 100%;
}
.cmp-name {
  font-size: 15px;
  font-family: roboto;
  line-height: 22px;
  padding: 5px;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
    .name{
        height: 60px;
    }
    .serv-box {
        text-align: center;
        margin-bottom: 20px;
    }
    .serv-box h3 {
        font-size: 22px;
        font-family: ' Montserrat';
        font-weight: bold;
    }
    .serv-box p {
        font-size: 14px;
        font-family: roboto;
        line-height: 22px;
    }
.how-it-works{
    background: #E5F7FF;
    padding: 30px 10px;
    font-family: Montserrat;
    text-align: center;
}
.steps{
    margin-top: 25px;
}
.step{
    background: #FFFFFF;
    box-shadow: 0px 0px 14px 1px rgba(0, 0, 0, 0.25);
    height: 250px;
    padding: 20px 10px;
    min-width: 200px;
    max-width: 250px;
    margin: auto;
    overflow: hidden;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    margin-bottom: 10px;
}
.step span{
    display: block;
    width: 0;
    height: 0;
    background: #0a8bba;
    position: absolute;
    top: -70px;
    left: -70px;
    border-radius: 50%;
    transition: all linear .35s;
    opacity: 0;
}
.step h3{
    margin-top: 45px;
    font-size: 18px;
    font-weight: 700;
    transition: all linear .35s;
    position: relative;
    z-index: 1;
}
.step img{
    max-height: 100px;
    transition: all linear .35s;
    position: relative;
    z-index: 1;
}
.step p{
    font-size: 14px;
    opacity: 0;
    transition: all linear .35s;
    position: relative;
    z-index: 1;
}

.step:hover p{
    display: block;
    transition: all linear .35s;
    opacity: 1;
    color: #fff;
}
.step:hover h3{
    font-size: 15px;
    margin-top: 10px;
    transition: all linear .35s;
    color: #fff;
}
.step:hover img{
    max-height: 80px;
    transition: all linear .35s;
}
.step:hover span{
    width: 380px;
    height: 380px;
    transition: all linear .35s;
    opacity: 0.9;
}
</style>

<script>

    import axios from 'axios'
    import login from './Login.vue'
    import updatesModal from './../components/updateRequiredDetail.vue';
    import '../../public/css/featured-companies.css';
    import {requestHeaders} from "../_helpers/apiHelper";

    export default {
        components: {
            login,
            updatesModal
        },
        data: function () {
            return {
                companiesLength: false,
                profilesLength: false,
                companies: {},
                profiles: {},
                featuredComs: []
            }
        },
        mounted() {
            if (this.validateUser()) {
                $('#updatesModal').modal('show');
            }
            var url = this.$store.getters.getDomain;
            axios({
                method: 'POST',
                url: `${url}api/v2/list/home-list`,
                headers: requestHeaders()
            }).then(data => {
                this.companies = data['data']['response']['companies'];
                this.profiles = data['data']['response']['profiles'];
                if (data['data']['response']['companies'].length > 6) {
                    this.companiesLength = true
                }
                if (data['data']['response']['profiles'].length > 6) {
                    this.profilesLength = true
                }
            }).catch(err => {
                  console.log(err)
              })

            var a = this;
            axios({
              method: 'POST',
              url: `${url}api/v2/utilities/featured-companies`
            }).then(function (response){
              if(response['data']['response']['status'] == 200){
                a.featuredComs = response['data']['response']['org'];
              }
            })

        },
        methods: {
            authModal() {
                $('#myModal').css({"display": "block"});
            },
            validateUser() {
                if (this.$store.getters.getUser['user_type'] == "Individual" && this.$store.getters.getUser['user_other_detail'] == false) {
                    return true;
                } else {
                    return false;
                }
            }
        },
        computed: {
            whetherLogged: function () {
                return this.$store.getters.getAuthState;
            }
        }
    }
</script>

